export default () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1 2.37881C1 1.73742 1.66723 1.31399 2.24757 1.58709L14.1926 7.20828C14.8625 7.52353 14.8625 8.47647 14.1926 8.79172L2.24757 14.4129C1.66723 14.686 1 14.2626 1 13.6212V10.0537C1 9.626 1.30924 9.26096 1.73115 9.19064L8.875 8L1.73115 6.80936C1.30924 6.73904 1 6.374 1 5.94626V2.37881Z"
      fill="#4451DE"
    />
  </svg>
)
